import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { DisplayBox, Loading } from "../components";
import { ApiHelper, ArrayHelper, TemplateInterface, ToastHelper } from "../helpers";

interface Props {

}


export const TemplatesPage: React.FC<Props> = props => {
  const [messageTemplates, setMessageTemplates] = React.useState<TemplateInterface[]>(null);
  const [overlayTemplates, setOverlayTemplates] = React.useState<TemplateInterface[]>(null);


  const init = () => {
    ApiHelper.get<TemplateInterface[]>("/templates")
      .then((data) => {
        setMessageTemplates(ArrayHelper.getAll(data || [], "templateType", "message"));
        setOverlayTemplates(ArrayHelper.getAll(data || [], "templateType", "overlay"));
      })
      .catch(err => {
        console.error("Failed to load templates:", err);
        ToastHelper.error("Failed to load templates");
      });
  }
  React.useEffect(init, [])


  const getTable = (templates: TemplateInterface[], displayName: string) => {
    if (!templates) return <Loading />
    if (templates.length === 0) return <p>No {displayName} templates have been created yet. Click the +New buton to add a new template.</p>
    else {
      const rows: React.ReactElement[] = [];
      templates.forEach(t => { rows.push(<tr key={t.id}><td><Link to={"/settings/templates/" + t.id}>{t.name}</Link></td></tr>) });
      return (<table className="table table-sm table-striped">
        <thead><tr><th>Name</th></tr></thead>
        <tbody>{rows}</tbody>
      </table>)
    }
  }

  const getNewButton = (templateType: string) => {
    return <Link to={"/settings/templates/0?templateType=" + templateType} className="btn btn-sm btn-success"><i className="fas fa-plus" style={{ color: "#FFF" }}></i> New</Link>
  }



  return (
    <div className="page-container">
      <div className="page-header">
        <h1><i className="fas fa-code"></i> Templates</h1>
        <p className="page-subtitle">Templates can be useful when you want to create multiple messages with very similar appearance. You can define the layout of the template once, then add multiple messages that pass values to the template. Although it can be a time saver once set up, this is an advanced option and requires knowledge of HTML. Most users choose to upload image or video creatives instead, or use one of our public templates.</p>
      </div>
      <Row>
        <Col lg={6}>
          <DisplayBox headerText="Message Templates" headerIcon="fas fa-code" editContent={getNewButton("message")} >
            {getTable(messageTemplates, "message")}
          </DisplayBox>
        </Col>
        <Col lg={6}>
          <DisplayBox headerText="Overlay Templates" headerIcon="fas fa-code" editContent={getNewButton("overlay")} >
            {getTable(overlayTemplates, "overlay")}
          </DisplayBox>
        </Col>
      </Row>
    </div>
  );
};